package xyz.malefic.gallery.ui

import kotlinx.browser.localStorage

// Constants
private const val DM_FOLDER_PASSWORD_KEY = "gallery:dmFolderPassword"
private const val CORRECT_PASSWORD = "maleficdmsaccess" // Replace with your desired password

// Password management functions
object PasswordManager {
    fun checkPassword(password: String): Boolean = password == CORRECT_PASSWORD

    fun savePassword(password: String) {
        if (checkPassword(password)) {
            localStorage.setItem(DM_FOLDER_PASSWORD_KEY, password)
        } else {
            clearPassword()
        }
    }

    fun clearPassword() {
        localStorage.removeItem(DM_FOLDER_PASSWORD_KEY)
    }

    fun isPasswordSaved(): Boolean {
        val savedPassword = localStorage.getItem(DM_FOLDER_PASSWORD_KEY)
        return savedPassword != null && checkPassword(savedPassword)
    }
}

// Helper function to check if a folder is the DM folder
fun isFolderPasswordProtected(folderName: String): Boolean = folderName == "DM"
